import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  signal,
} from '@angular/core';
import {
  ButtonComponent,
  IconComponent,
  PopoverComponent,
  PopoverPlacement,
} from '@ui';
import { TranslocoDirective } from '@jsverse/transloco';
import { FiltersFormComponent } from '../filters-form/filters-form.component';
import { FilterConfig, FilterFormValue } from '../../../models/filters.models';
import { Filter } from '@data';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    PopoverComponent,
    ButtonComponent,
    IconComponent,
    FiltersFormComponent,
    TranslocoDirective,
  ],
  selector: 'ui-filters-popover',
  template: `
    <ng-container *transloco="let t">
      <ui-popover
        [placement]="placement()"
        [visible]="visible()"
        (popoverVisibleChange)="setVisiblePopover($event)"
      >
        <!-- Popover trigger -->
        <ui-button buttonType="dashed" [disabled]="disabled()">
          @if (numFilters() > 0) {
            <ui-icon icon="filter" />
            {{ numFilters() }}
            {{
              numFilters() === 1
                ? t('FILTERS.POPOVER.BUTTON_LABEL_SINGULAR')
                : t('FILTERS.POPOVER.BUTTON_LABEL_PLURAL')
            }}
          } @else {
            <ui-icon icon="plus" />
            {{ t('FILTERS.POPOVER.ADD_BUTTON_LABEL') }}
          }
        </ui-button>

        <!-- The content of the popover is provided as a template -->
        <div popover-content class="w-[640px]">
          <ui-filters-form
            (onApplyFilters)="applyFilters($event)"
            [optionsFilter]="optionsFilter()"
          />
        </div>
      </ui-popover>
    </ng-container>
  `,
})
export class FiltersPopoverComponent {
  optionsFilter = input<FilterConfig[]>();

  // When true, disables the trigger button that opens the popover
  disabled = input<boolean>(false);

  placement = input<PopoverPlacement>('bottom');
  visible = signal<boolean>(false);
  filters = signal<FilterFormValue[]>([]);
  numFilters = computed<number>(() => this.filters()?.length || 0);
  onFilter = output<Filter[]>();

  setVisiblePopover(visible: boolean) {
    this.visible.set(visible);
  }

  applyFilters(filters: FilterFormValue[]) {
    this.setVisiblePopover(false);
    this.filters.set(filters);
    this.onFilter.emit(filters);
  }
}
